<template>
  <div>
    <main>
      <div class="wide-wrapper">
        <h2>Cadillac Arm Springs</h2>
        <!-- <h3>Placeholder</h3> -->

        <div class="upper-content-wrapper">
          <photo-grid :feature="featureImgHtml">
            <photo
              @setFeature="setFeatureImg"
              src="cadillac-armsprings1@1x.jpg"
              src2="cadillac-armsprings1@2x.jpg"
              alt="Cadillac Arm springs closeup"
            />
            <photo
              @setFeature="setFeatureImg"
              src="cadillac-armsprings2@1x.jpg"
              src2="cadillac-armsprings2@2x.jpg"
              alt="Cadillac Arm springs full shot"
            />
            <photo
              @setFeature="setFeatureImg"
              src="cadillac-armsprings3@1x.jpg"
              src2="cadillac-armsprings3@2x.jpg"
              alt="Cadillac Arm springs in action"
            />
          </photo-grid>

          <cta-prod-button
            class="cta-button wide"
            link="cadillac"
            src="contrology-cad1@1x.jpg"
            src2="contrology-cad1@2x.jpg"
            alt="Close-up photo of Contrology Cadillac thumbnail"
            productName="Contrology Cadillac"
            productSub='All models'
          />

          <div class="content-wrapper">
            <section class="intro">
              <h2>Cadillac Arm Springs</h2>
              <!-- <h3>Placeholder</h3> -->
              <p>
                This spring can be differentiated from the Roll Back Bar Spring by a twist in the end loops. 
                <br><br>
                This spring has a "neck down" design which means that there are reduced coils near the end of the spring. When combined with the wider coils in the body of the spring it blends the properties of two springs into one.    
                <!-- <span
                  v-show="!show"
                  class="content-link"
                  @click="toggleContent"
                  role="button"
                  tabindex="0"
                >
                  More ›
                </span> -->
              </p>
              <!-- <div v-show="show">
                <p>
                    This spring has the "neck down" design which means that there are reduced coils near the end of the spring. When combined with the wider coils in the body of the spring it blends the properties of two springs into one.                  
                  <span
                    v-show="show"
                    class="content-link"
                    @click="toggleContent"
                    role="button"
                    tabindex="0"
                  >
                    Less ›
                  </span>
                </p>
              </div> -->
            </section>

            <product-selector
              :products=products
              :product=product
              :option1=option1
              :option2=option2
              :isdistcountry=isdistcountry
              :fsahsa="true"
            />

            <p class="post-note">
              *<b>Note:</b> Snap clips are not included with Springs. Please call us (916) 388-2838 or <a href="mailto:info@pilates.com">email info@pilates.com</a> to purchase snap clips separately.
            </p>

            <section class="links">
              <icon-link
                url="warranty"
                img="icon-warranty.svg"
                alt="Warranty icon"
                title="Learn more"
              >2 Year Limited Warranty</icon-link>
              <icon-link
                url="support"
                img="icon-assembly.svg"
                alt="Assembly icon"
                title="Learn more"
              >Assembly &amp; Support</icon-link>
            </section>

            <modal-card-large v-if="showCardModal" @close="showCardModal = false" />

            <cta-prod-button
              class="cta-button"
              link="cadillac"
              src="contrology-cad1@1x.jpg"
              src2="contrology-cad1@2x.jpg"
              alt="Close-up photo of Contrology Cadillac thumbnail"
              productName="Contrology Cadillac"
              productSub='All models'
            />

            <section class="more">
              <tertiary-button text="More Cadillac Accessories" url="/accessories/Cadillac" />
            </section>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import PhotoGrid from "@/components/PhotoGrid.vue";
import Photo from "@/components/Photo.vue";
import ProductSelector from "@/components/ProductSelector.vue";
import IconLink from "@/components/IconLink.vue";
import ModalCardLarge from "@/components/ModalCardLarge.vue";
import CtaProdButton from "@/components/CtaProdButton.vue";
import TertiaryButton from "@/components/TertiaryButton.vue";

export default {
  name: "cadillacarmsprings",

  metaInfo: {
    title: "Contrology Cadillac Arm Springs - Balanced Body",
    titleTemplate: "%s",
    meta: [
      {
        name: "description",
        content: "Looking for Cadillac Arm Springs? This Contrology Arm Spring has a neck down design with reduced coils near the end of the spring. Get your Pilates Springs now."
      }
    ]
  },

  components: {
    PhotoGrid,
    Photo,
    ProductSelector,
    IconLink,
    ModalCardLarge,
    CtaProdButton,
    TertiaryButton
  },

  props: {
    isdistcountry: Boolean
  },

  data() {
    return {
      featureImgHtml: "", // PhotoGrid
      showCardModal: false, // ModalCard
      show: false, // Intro content
      product: {
        label: "Select",
        value: "",
        key: "name"
      },
      option1: {},
      option2: {},
      products: [
        // Product options
        {
          prodid: 41267990986945,
          partnumber: 17109,
          price: 35,
          name: "Cadillac Arm Spring, single",
          available: true
        },
        {
          prodid: 41267991019713,
          partnumber: 17883, 
          price: 70,
          name: "Cadillac Arm Springs, pair",
          available: true
        }
      ]
    };
  },
  
  methods: {
    // Set PhotoGrid featured image
    setFeatureImg(html) {
      this.featureImgHtml = html;
    },

    // Toggle intro content
    toggleContent() {
      this.show = !this.show;
    }
  }
};
</script>

<style lang="scss" scoped>
h2 {
  text-align: center;
  margin: 0;
  padding: 0;
}

h2 + h3 {
  display: none;
}

.intro h2 {
  display: none;
}

.intro h3 {
  display: block;
}

.intro p {
  font-family: var(--roboto);
  font-size: 0.9375rem;
  line-height: 1.467;
  color: #333;
}

.content-link {
  text-decoration: underline;
  cursor: pointer;
}

.wide {
  display: none;
}

.links {
  margin-top: 30px;
}

.krn-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  max-width: 530px;
  margin: 0 auto;
  margin-top: 3rem;
}

.krn-image-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin: 0 auto;
  padding-right: 0;
}

.krn-image-container img {
  width: 180px;
  height: 180px;
}

.krn-image-container p {
  font-size: 10px;
  margin: 1rem 0 0 0;
}

.krn-quote-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 2rem 0;
}

.krn-quote {
  margin-bottom: 24px;
  margin-top: 0;
  font-size: 18px;
  font-family: var(--noto);
  font-style: italic;
}

.krn-name {
  font-weight: 500;
  font-size: 15px;
  margin: 0;
}

.post-note {
  -webkit-box-ordinal-group: 3;
  -ms-flex-order: 3;
  order: 3;
  font-family: var(--roboto);
  font-size: 0.75rem;
  line-height: 1.25;
  color: var(--black);
  margin-bottom: 12px;
}

@media only screen and (min-width: 768px) {
  h2 + h3 {
    display: block;
    margin: 0;
  }

  .intro h3 {
    display: none;
  }

  .upper-content-wrapper {
    padding: 0 80px;
  }

  .content-wrapper {
    max-width: 530px;
    margin: 0 auto;
  }

  .links {
    column-count: 3;
    position: relative;
    margin-top: 15px;
  }

  .links > * {
    -webkit-column-break-inside: avoid;
    page-break-inside: avoid;
    break-inside: avoid;
  }

  .icon-link {
    margin-top: 0;
  }

  ::v-deep .modal-card-wrapper {
    position: absolute;
    top: 100%;
    left: 10%;
    width: 80%;
    margin: 0 auto;
  }
}

@media only screen and (min-width: 1024px) {
  .upper-content-wrapper {
    padding: 0 45px;
    display: flex;
    align-items: flex-start;
    max-width: 900px;
    margin: 0 auto 30px;
  }

  .content-wrapper {
    width: 340px;
    display: flex;
    flex-flow: column nowrap;
  }

  .intro {
    order: 1;
    margin-top: 15px;
  }

  .cta-button {
    order: 3;
    margin: 20px 0 10px;
  }

  .links {
    column-count: 1;
    order: 4;
  }

  ::v-deep .modal-card-wrapper {
    top: 60%;
  }

  .icon-link {
    margin: 0;
  }

  .more {
    order: 5;
    margin-top: 20px;
  }

  .krn-container {
    max-width: 775px;
  }

  .krn-container {
    flex-direction: row;
  }

  .krn-image-container {
    margin: 0;
    padding-right: 2rem;
  }
}

@media only screen and (min-width: 1208px) {
  .wide-wrapper {
    background-color: rgba(255, 255, 255, 0.75);
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto auto auto;
    position: relative;
    z-index: 0;
    max-width: 1050px;
    margin: 0 auto;
  }

  .upper-content-wrapper {
    display: contents;
  }

  .photo-grid-wrapper {
    grid-column: 1 / span 1;
    grid-row: 1 / span 2;
  }

  .content-wrapper {
    width: auto;
    grid-column: 2 / span 1;
    grid-row: 1 / span 1;
    margin: 50px 30px 20px 0;
    max-width: 600px;
  }

  .cta-button {
    display: none;
  }

  .cta-button.wide {
    display: flex;
    grid-column: 1 / span 1;
    grid-row: 3 / span 1;
    justify-self: center;
    margin: 0 80px 30px auto;
  }

  .intro h2,
  .intro h3 {
    display: block;
    text-align: left;
  }

  .wide-wrapper > h2,
  .wide-wrapper > h3 {
    display: none;
  }

  .links {
    column-count: 2;
    max-width: 400px;
  }

  ::v-deep .modal-card-wrapper {
    top: 20px;
  }

  .icon-link {
    margin: 1px;
  }
}
</style>
